import { ColmatageLit } from '../SANDRE/colmatage-lit';
import { Materiel } from './materiel';
import { NatureVegetationPlacette } from '../SANDRE/nature-vegetation';
import { ImportanceVegetationPlacette } from '../SANDRE/importance-vegetation-placette';
import { ESousSubstrat } from './enum/sous-substrat';

export class Prelevement {

    id: number;
    prelevementVitesseId: number;

    Numero: number;
    Profondeur: number;
    Colmatage: ColmatageLit;
    Intensite: number;
    Vegetation: NatureVegetationPlacette;
    Abondance: ImportanceVegetationPlacette;
    Materiel: Materiel;
    Commentaire: string;
    SousSubstrat: ESousSubstrat;

    static mapFromJSON(json): Prelevement {
        const p = new Prelevement();

        p.Numero = json.numero;
        p.Profondeur = json.profondeur;
        p.Commentaire = json.commentaire;
        p.Colmatage = json.colmatage;
        p.Abondance = json.abondance;
        p.Materiel = json.materiel;
        p.Vegetation = json.vegetation;
        p.Intensite = json.intensite;
        p.SousSubstrat = json.sousSubstrat;

        return p;
    }
}
